import React from 'react';
import { LayoutDashboard, MessageSquare, BarChart3, Settings, TrendingUp, Eye, Heart, MousePointer } from 'lucide-react';
import { DashboardLayout } from '../../components/DashboardLayout';
export function PerformancePage() {
  const navItems = [{
    label: 'My Listings',
    icon: LayoutDashboard,
    path: '/dashboard/seller'
  }, {
    label: 'Inquiries',
    icon: MessageSquare,
    path: '/seller/inquiries',
    badge: '5 New'
  }, {
    label: 'Performance',
    icon: BarChart3,
    path: '/seller/performance'
  }, {
    label: 'Settings',
    icon: Settings,
    path: '/seller/settings'
  }];
  return <DashboardLayout title="Seller Dashboard" navItems={navItems} userInitials="RK" data-id="element-5521">
      <h1 className="text-2xl font-bold mb-8" data-id="element-5522">Listing Performance</h1>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8" data-id="element-5523">
        <div className="bg-white border border-gray-300 p-6" data-id="element-5524">
          <div className="flex items-center gap-3 mb-2" data-id="element-5525">
            <div className="p-2 bg-blue-50 rounded" data-id="element-5526">
              <Eye className="w-5 h-5 text-blue-600" data-id="element-5527" />
            </div>
            <h3 className="text-xs font-mono text-gray-500 uppercase" data-id="element-5528">
              Total Views
            </h3>
          </div>
          <p className="text-3xl font-bold" data-id="element-5529">1,248</p>
          <p className="text-xs text-green-600 mt-1 font-mono" data-id="element-5530">
            +12% this week
          </p>
        </div>
        <div className="bg-white border border-gray-300 p-6" data-id="element-5531">
          <div className="flex items-center gap-3 mb-2" data-id="element-5532">
            <div className="p-2 bg-red-50 rounded" data-id="element-5533">
              <Heart className="w-5 h-5 text-red-600" data-id="element-5534" />
            </div>
            <h3 className="text-xs font-mono text-gray-500 uppercase" data-id="element-5535">
              Shortlisted
            </h3>
          </div>
          <p className="text-3xl font-bold" data-id="element-5536">42</p>
          <p className="text-xs text-green-600 mt-1 font-mono" data-id="element-5537">+5% this week</p>
        </div>
        <div className="bg-white border border-gray-300 p-6" data-id="element-5538">
          <div className="flex items-center gap-3 mb-2" data-id="element-5539">
            <div className="p-2 bg-purple-50 rounded" data-id="element-5540">
              <MousePointer className="w-5 h-5 text-purple-600" data-id="element-5541" />
            </div>
            <h3 className="text-xs font-mono text-gray-500 uppercase" data-id="element-5542">CTR</h3>
          </div>
          <p className="text-3xl font-bold" data-id="element-5543">3.8%</p>
          <p className="text-xs text-gray-500 mt-1 font-mono" data-id="element-5544">
            Avg market: 2.1%
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-5545">
        <div className="bg-white border border-gray-300 p-6" data-id="element-5546">
          <h3 className="font-bold text-lg mb-6" data-id="element-5547">Views Over Time</h3>
          <div className="h-64 border-2 border-dashed border-gray-200 bg-gray-50 flex items-center justify-center" data-id="element-5548">
            <div className="text-center text-gray-400" data-id="element-5549">
              <TrendingUp className="w-8 h-8 mx-auto mb-2" data-id="element-5550" />
              <span className="font-mono text-sm" data-id="element-5551">
                [Line Chart Placeholder]
              </span>
            </div>
          </div>
        </div>

        <div className="bg-white border border-gray-300 p-6" data-id="element-5552">
          <h3 className="font-bold text-lg mb-6" data-id="element-5553">Top Performing Listings</h3>
          <div className="space-y-4" data-id="element-5554">
            {[{
            name: 'Premium Corner Plot',
            views: 842,
            inquiries: 12,
            score: 95
          }, {
            name: 'Wakad Land Parcel',
            views: 406,
            inquiries: 5,
            score: 72
          }].map((item, i) => <div key={i} className="border border-gray-200 p-4" data-id="element-5555">
                <div className="flex justify-between mb-2" data-id="element-5556">
                  <span className="font-bold text-sm" data-id="element-5557">{item.name}</span>
                  <span className="font-mono text-xs font-bold text-green-600" data-id="element-5558">
                    Score: {item.score}
                  </span>
                </div>
                <div className="flex gap-4 text-xs text-gray-500 font-mono" data-id="element-5559">
                  <span data-id="element-5560">{item.views} Views</span>
                  <span data-id="element-5561">{item.inquiries} Inquiries</span>
                </div>
                <div className="mt-3 h-1.5 bg-gray-100 rounded-full overflow-hidden" data-id="element-5562">
                  <div className="h-full bg-[#1f2933]" style={{
                width: `${item.score}%`
              }} data-id="element-5563"></div>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </DashboardLayout>;
}